exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input{color:#000;margin-left:auto;margin-right:auto;width:100%;padding:4px}.popup{z-index:9001;margin:0;padding:0;display:block;position:absolute;background-color:#fff;min-width:50px;overflow:hidden;overflow-y:auto;max-height:260px;list-style-type:none;border:1px solid rgba(0,0,0,.35);box-shadow:3px 4px 5px rgba(0,0,0,.2)}.popup-text,.popup-text-selected{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;color:#000;margin:0;text-align:left;padding:0 10px}.popup-text-selected{font-weight:700;background-color:#eee!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/app/components/AutoTaskInput.less
 ** module id = 751
 ** module chunks = 9
 **/